import React, { useState, useEffect } from 'react';
import { submitContactForm } from '../../utils/api';
import { useLanguage } from '../../contexts/LanguageContext';
import { getLocalizedValue, siteContent } from '../../data/siteContent';

const ContactForm = () => {
	const { language } = useLanguage();
	const labels = siteContent.contact;
	const [formData, setFormData] = useState({
		name: '',
		email: '',
		message: ''
	});
	const [status, setStatus] = useState({ type: '', message: '' });
	const [isSubmitting, setIsSubmitting] = useState(false);

	useEffect(() => {
		setStatus({ type: '', message: '' });
	}, [language]);

	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData(prev => ({
			...prev,
			[name]: value
		}));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setIsSubmitting(true);
		setStatus({ type: '', message: '' });

		try {
			const response = await submitContactForm(formData);
			if (response.success) {
				setStatus({
					type: 'success',
					message: getLocalizedValue(labels.successMessage, language)
				});
				setFormData({ name: '', email: '', message: '' });
			}
		} catch (error) {
			setStatus({
				type: 'error',
				message: getLocalizedValue(labels.errorMessage, language)
			});
		} finally {
			setIsSubmitting(false);
		}
	};

	return (
		<form className="contact-form" onSubmit={handleSubmit}>
			<div className="form-group">
				<label htmlFor="name" className="form-label">{getLocalizedValue(labels.nameLabel, language)} *</label>
				<input
					type="text"
					id="name"
					name="name"
					className="form-input"
					value={formData.name}
					onChange={handleChange}
					required
				/>
			</div>

			<div className="form-group">
				<label htmlFor="email" className="form-label">{getLocalizedValue(labels.mailLabel, language)} *</label>
				<input
					type="email"
					id="email"
					name="email"
					className="form-input"
					value={formData.email}
					onChange={handleChange}
					required
				/>
			</div>

			<div className="form-group">
				<label htmlFor="message" className="form-label">{getLocalizedValue(labels.messageLabel, language)} *</label>
				<textarea
					id="message"
					name="message"
					className="form-textarea"
					value={formData.message}
					onChange={handleChange}
					required
				/>
			</div>

			{status.message && (
				<div className={`form-status ${status.type}`}>
					{status.message}
				</div>
			)}

			<button type="submit" className="btn btn-primary agua-crooked-frame" disabled={isSubmitting}>
				{isSubmitting ? getLocalizedValue(labels.sending, language) : getLocalizedValue(labels.sendMessage, language)}
			</button>
		</form>
	);
};

export default ContactForm;
